import axiosInstance from "../lib/axiosInstance";

class roleModel {

    constructor() {
        this.base_url = "/roles"
    }
    async list(query = []) {
       
        return (await axiosInstance.get(`${this.base_url}?${new URLSearchParams(query)}`)).data;
    }
    
    async permission(query = []) {
       
        return (await axiosInstance.get(`${'/permissions'}?${new URLSearchParams(query)}`)).data;
    }
     async create(data=[]) {
        return await axiosInstance.post(this.base_url, data);
    }
    async update(id, data = []) {
        return await axiosInstance.put(`${this.base_url}/${id}?_method=PUT`, data);
    }
    async destroy(id,data=[]) {
        return await axiosInstance.delete(`${this.base_url}/${id}`, data);
    }
    async show(id) {
        return (await axiosInstance.get(`${this.base_url}/${id}`)).data;
    }
       

}

export default new roleModel();